import * as React from 'react';

export default () => (
  <svg width="16" height="16" fill="none">
    <path d="M4 4l8 8M12 4l-8 8" stroke="#F02929" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
